import { useCopyScoreDisplayToReports } from './useScoreDisplay';
import { useCopyShowNamesToReports } from './useShowNames';
import { useCopyShowResponseToReport } from './useShowResponses';
import { useCopyShowResultsToReport } from './useShowResults';

export function useCopyAllToReports() {
  const copyShowResultsToReport = useCopyShowResultsToReport();
  const copyShowNamesToReports = useCopyShowNamesToReports();
  const copyShowResponseToReport = useCopyShowResponseToReport();
  const copyScoreDisplayToReports = useCopyScoreDisplayToReports();

  return () => {
    copyShowResultsToReport();
    copyShowNamesToReports();
    copyShowResponseToReport();
    copyScoreDisplayToReports();
  };
}
